document.addEventListener("latte:init", init);

function init () {
    var _ = require('lodash');

    ie = navigator.userAgent.match(/(MSIE |Trident.*rv[ :])([0-9]+)/) && navigator.userAgent.match(/(MSIE |Trident.*rv[ :])([0-9]+)/)[2];

    if (ie !== null && ie <= 11) {
        $('.pricing-table-item').mouseenter(function (e) {
            $(this).addClass('ieHover');
            $(this).find('.product-row').addClass('ieHover');
        }).mouseleave(function (e) {
            $(this).removeClass('ieHover');
            $(this).find('.product-row').removeClass('ieHover');
        });
    }

    $('.searchByZip').on('submit', function (e) {
        zipCode = $(this).find('.zip-code-field').val();
        redirectUrl = $(this).find('.redirectUrl').val();
        window.location.href = redirectUrl + "?zip=" + zipCode;
        e.preventDefault();
    });

    $('.zip-code-field').on('keyup', function () {
        if ($(this).val().length >= 5) {
            $(this).parent().find('.btn-primary').removeClass('disabled');
        } else {
            $(this).parent().find('.btn-primary').addClass('disabled');
        }

    });

    var tabsToAccordian = {
        initialUlClass: '.tabs-accordion',
        accordian: null,
        tabs: null,
        activeClass: 'is-active',
        accordianUlClass: 'accordion',
        accordianUlAttr: 'data-accordion',
        accordianItemAttr: 'data-accordion-item',
        accordianItemClass: 'accordion-item',
        accordianTitleClass: 'accordion-title',
        accordianContentClass: 'accordion-content',
        accordianContentAttr: 'data-tab-content',
        tabsUlClass: 'tabs',
        tabsUlAttr: 'data-tabs',
        tabsItemClass: 'tabs-title',
        tabsContentClass: 'tabs-panel',
        tabsMainContainer: 'tabs-content',
        init: function () {
            if (Foundation.MediaQuery.current == 'small') {
                this.toAccordian();
            } else {
                this.toTabs();
            }
        },
        toTabs: function () {
            if (!$(this.initialUlClass).hasClass(this.tabsUlClass)) {
                //start at the main ul
                $(this.initialUlClass)
                    .removeClass(this.accordianUlClass)
                    .addClass(this.tabsUlClass)
                    .removeAttr(this.accordianUlAttr)
                    .removeAttr('role')
                    .attr(this.tabsUlAttr, '');
                $('.' + this.accordianItemClass).each(function (index) {
                    $(this)
                        .removeClass(tabsToAccordian.accordianItemClass)
                        .removeClass(tabsToAccordian.activeClass)
                        .removeAttr('role')
                        .removeAttr(tabsToAccordian.accordianItemAttr)
                        .addClass(tabsToAccordian.tabsItemClass);
                    tabsToAccordian.addActive(this, index);
                    //get the corrisponding content by index (there should be x tabs x panels)
                    var corrispondingContent = $('.' + tabsToAccordian.accordianContentClass).eq(0);
                    corrispondingContent
                        .removeClass(tabsToAccordian.accordianContentClass)
                        .removeClass(tabsToAccordian.activeClass)
                        .removeAttr(tabsToAccordian.accordianContentAttr)
                        .removeAttr('role')
                        .addClass(tabsToAccordian.tabsContentClass);
                    tabsToAccordian.addActive('#' + corrispondingContent.attr('id'), index);
                    $(this).find('a').removeAttr('role aria-selected aria-expanded')
                        .removeClass(tabsToAccordian.accordianTitleClass);
                    $('.' + tabsToAccordian.tabsMainContainer).append(corrispondingContent);
                });
                this.tabs = new Foundation.Tabs($(this.initialUlClass));
            }
        },
        toAccordian: function () {
            if (!$(this.initialUlClass).hasClass(this.accordianUlClass)) {

                //start at the main ul
                $(this.initialUlClass)
                    .removeClass(this.tabsUlClass)
                    .addClass(this.accordianUlClass)
                    .removeAttr(this.tabsUlAttr)
                    .removeAttr('role')
                    .attr(this.accordianUlAttr, '');
                //then start at the titles

                $('.' + this.tabsItemClass).each(function (index) {

                    //main li construct
                    $(this)
                        .removeClass(tabsToAccordian.tabsItemClass)
                        .removeClass(tabsToAccordian.activeClass)
                        .removeAttr('style')
                        .attr(tabsToAccordian.accordianItemAttr, '')
                        .addClass(tabsToAccordian.accordianItemClass);

                    tabsToAccordian.addActive(this, index);

                    // get the corrisponding content by index (there should be x tabs x panels)
                    var corrispondingContent = $('.' + tabsToAccordian.tabsContentClass).eq(0);



                    //mdify class and attr
                    corrispondingContent
                        .addClass(tabsToAccordian.accordianContentClass)
                        .attr(tabsToAccordian.accordianContentAttr, '')
                        .removeAttr('role')
                        .removeClass(tabsToAccordian.tabsContentClass);

                    //add the class to the title
                    $(this).find('a')
                        .removeAttr('role aria-selected aria-expanded')
                        .addClass(tabsToAccordian.accordianTitleClass)
                        .after(corrispondingContent);
                });

                var options = { multiExpand: false, allowAllClosed: true };
                this.accordian = new Foundation.Accordion($(this.initialUlClass), options);
            }
        },
        addActive: function (element, index) {
            if (index === 0) {
                $(element).addClass('is-active');
            }
            return this;
        }
    };

    if ($(".class-schedule").length > 0 && $('#session-tabs').length > 0) {
        tabsToAccordian.init();
    }

    $('.secondary-highlights--expand').click(function (e) {
        $('.feature-collapsed').addClass("expanded");
        $('.feature-collapsed .medium-offset-1').removeClass("medium-offset-1");
        $('.feature-collapsed .medium-6').addClass("medium-7");
        $('.secondary-highlights--expand').fadeOut();
        $('.feature-collapsed .close').show();
        $('.feature-expanded').slideDown();
        e.preventDefault();
    });

    $('.secondary-highlights--collapse').click(function (e) {
        $('.feature-expanded').slideUp();
        $('.feature-collapsed').removeClass("expanded");
        $('.feature-collapsed').addClass("medium-offset-1");
        $('.feature-collapsed .medium-7').removeClass("medium-7");
        $('.secondary-highlights--expand').fadeIn();
        $('.feature-collapsed .close').fadeOut();

        e.preventDefault();
    });

    $('.tutoring-table .toggle-tab').click(function (e) {
        $('.toggle-tab').removeClass("active");
        $(this).addClass("active");
        $(".product-point").addClass("hide");
    });

    $('.toggle-tab.inperson-tab').click(function (e) {
        $(".product-point.in-person").removeClass("hide");
        $(".product-point.in-person").show();
        $('.person-info').show();
        $('.online-info').hide();
    });

    $('.toggle-tab.online-tab').click(function (e) {
        $(".product-point.online").removeClass("hide");
        $(".product-point.online").show();
        $('.person-info').hide();
        $('.online-info').show();
    });

    helper.zipAutoComplete({
        selector: '#tutoring-zip-search',
        onSelect: function () {
            var zip = $('#tutoring-zip-search').val();
            var tutoringIds = [];
            $(".inPerson").each(function (x) {
                id = $(this).attr('data-product-id');
                tutoringIds.push(id);
            });
            var newPrice = helper.getProductPrices(tutoringIds, zip);
            if (newPrice) {
                var prices = newPrice.productPriceList;
                prices.forEach(function (p) {
                    if (p.salePrice === 0) {
                        $('[data-product-id="' + _.replace(p.productId, 'dprod', '') + '"]').html('<p><strong>' + content.callForPrice + '</strong></p>');
                    } else {
                        var href = $('[data-product-id="' + _.replace(p.productId, 'dprod', '') + '"]').attr("page-link"); //shopping card url
                        var label = $('[data-product-id="' + _.replace(p.productId, 'dprod', '') + '"]').attr("button-label"); //shopping card url
                        //Update pricing info base on user input zip
						if (p.salePrice < p.listPrice) {
							$('[data-product-id="' + _.replace(p.productId, 'dprod', '') + '"]').html('<span class="price-span">' + p.currency + '<span class="pricing">' + Math.ceil(p.salePrice) + '</span> <span class="list-price-strike">' + p.currency + p.listPrice + '</span></span><br/><a class="btn btn--primary btn--small" href="' + href + '" >' + label + '</a>');
                        } else {
                            $('[data-product-id="' + _.replace(p.productId, 'dprod', '') + '"]').html('<span class="price-span">' + p.currency + '<span class="pricing">' + p.salePrice + '</span> <br/><a class="btn btn--primary btn--small" href="' + href + '" >' + label + '</a>');
                        }
                    }
                });
            }
        }
    });

    var allFeaturedItems = $(".feature-item");
    if (allFeaturedItems.length % 2 !== 0) {
        $(allFeaturedItems).last().addClass("small-12");
    }

}


//////////////////
// WEBPACK FOOTER
// ./public/js/products.js
// module id = 86
// module chunks = 0